// 课程表工具函数 - 从小程序迁移

/**
 * 获取当前日期一周内的时间
 * @param {Date} data 日期Date
 */
export const getCurrWeekList = (data) => {
  //根据日期获取本周周一~周日的年-月-日
  let weekList = [],
      date = new Date(data);
  //获取当前日期为周一的日期
  date.setDate(date.getDay() === 0 ? date.getDate() - 6 : date.getDate() - date.getDay() + 1);
  // push周一数据
  weekList.push(formateDate(date));
  //push周二以后日期
  for (var i = 0; i < 6; i++) {
      date.setDate(date.getDate() + 1);
      weekList.push(formateDate(date));
  }
  return weekList;
};

/**
 * 格式化日期
 * @param {Date} time 
 */
export const formateDate = (time) => {
  let year = time.getFullYear();
  let month = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1);
  let day = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
  return year + '-' + month + '-' + day;
};

/**
 * 计算两个日期之间的周数差
 * @param {string} startDate 开始日期
 * @param {string|Date} currentDate 当前日期
 */
export const weeksBetweenDates = (startDate, currentDate) => {
  const start = new Date(startDate.replace(/-/g, '/'));
  const current = typeof currentDate === 'string' ? new Date(currentDate.replace(/-/g, '/')) : new Date(currentDate);
  // 如果当前日期在学期开始之前，返回 0（表示学期尚未开始）
  if (current < start) return 0;
  const diffTime = current - start;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  // 周次应为 1 基：0~6 天为第 1 周，7~13 天为第 2 周 ...
  return Math.floor(diffDays / 7) + 1;
};

/**
 * 生成周次数据
 * @param {string} startTime 学期开始时间
 */
export const generateWeeksData = (startTime) => {
  const weeks = [];
  const start = new Date(startTime.replace(/-/g, '/'));
  
  for (let i = 1; i <= 20; i++) { // 假设一学期20周
    const weekStart = new Date(start);
    weekStart.setDate(start.getDate() + (i - 1) * 7);
    weeks.push({
      index: i,
      data: formateDate(weekStart)
    });
  }
  return weeks;
};

/**
 * 判断课程是否在当前周
 * 兼容：
 * - 7-18周
 * - 7-14,16-19周（支持中英文逗号）
 * - 7,9,11周
 * - 单周/双周（若出现，则在范围基础上再过滤奇偶）
 * @param {string} weekStr 课程周次描述
 * @param {number} currentWeek 当前周（1基）
 */
const isCourseInWeek = (weekStr, currentWeek) => {
  if (!weekStr || !currentWeek) return true; // 没周次信息则默认显示

  // 预处理
  const hasOdd = /单周/.test(weekStr);
  const hasEven = /双周/.test(weekStr);
  const normalized = weekStr
    .replace(/周/g, '')
    .replace(/，/g, ',')
    .replace(/\s+/g, '');

  // 提取纯数字、逗号和短横的片段
  const cleaned = normalized.replace(/[^\d,\-]/g, '');
  if (!cleaned) return true; // 若清理后无数据，保守显示

  const parts = cleaned.split(',').filter(Boolean);

  let inRange = false;
  for (const part of parts) {
    if (part.includes('-')) {
      const [aStr, bStr] = part.split('-');
      const a = parseInt(aStr, 10);
      const b = parseInt(bStr, 10);
      if (!isNaN(a) && !isNaN(b)) {
        const min = Math.min(a, b);
        const max = Math.max(a, b);
        if (currentWeek >= min && currentWeek <= max) {
          inRange = true;
          break;
        }
      }
    } else {
      const n = parseInt(part, 10);
      if (!isNaN(n) && n === currentWeek) {
        inRange = true;
        break;
      }
    }
  }

  if (!inRange) return false;

  // 奇偶周过滤（若标注单/双周）
  if (hasOdd && currentWeek % 2 === 0) return false;
  if (hasEven && currentWeek % 2 !== 0) return false;

  return true;
};

/**
 * 预处理课程数据
 * @param {number} currentWeek 当前周次
 * @param {Object} semester 学期数据
 */
export const preMix = (currentWeek, semester) => {
  const schedule = {};
  
  // 遍历周一到周日
  for (let day = 1; day <= 7; day++) {
    if (semester[day]) {
      schedule[day] = [];

      // 支持“大课”输入：若当天数组长度<=5，表示每一项是一个大课，需要扩展为两个连续小节
      const raw = semester[day];
      const isBigLessonInput = raw.length <= 5;
      const expanded = [];

      if (isBigLessonInput) {
        raw.forEach((item) => {
          // 每个大课（或0）扩展为两个相同的小节占位
          expanded.push(item, item);
        });
      } else {
        expanded.push(...raw);
      }

      // 上色与标准化（按小节处理，但颜色按“大课对”保持一致）
      const colors = ['255,182,193', '173,216,230', '144,238,144', '255,218,185', '221,160,221'];
      expanded.forEach((classItem, index) => {
        const pairIndex = Math.floor(index / 2); // 对应第几个大课
        if (typeof classItem === 'number') {
          // 空课时
          schedule[day][index] = { size: 1 };
        } else if (Array.isArray(classItem)) {
          // 多个课程选择
          // 优先挑选符合当前周的课程，否则退回第一个
          let picked = classItem.find(it => it && it.sub && isCourseInWeek(it.week, currentWeek));
          if (!picked) picked = classItem[0];
          if (picked && picked.sub && isCourseInWeek(picked.week, currentWeek)) {
            schedule[day][index] = {
              ...picked,
              color: picked.color || colors[pairIndex % colors.length],
              size: 1
            };
          } else {
            schedule[day][index] = { size: 1 };
          }
        } else if (classItem && classItem.sub) {
          // 正常课程
          if (isCourseInWeek(classItem.week, currentWeek)) {
            schedule[day][index] = {
              ...classItem,
              color: classItem.color || colors[pairIndex % colors.length],
              size: 1
            };
          } else {
            schedule[day][index] = { size: 1 };
          }
        } else {
          schedule[day][index] = { size: 1 };
        }
      });
    }
  }
  
  return schedule;
};

/**
 * 混合时间和课程数据
 * @param {Object} timeTable 时间表配置
 * @param {Object} schedule 课程安排
 */
export const minixTimeAndClass = (timeTable, schedule) => {
  const renderData = [];
  
  // 计算总课程数量
  const totalSlots = timeTable.time.length;
  
  // 先分时间表
  const tmpFen = timeTable.fen.map(e => e * 2);
  let indexSum = 1;
  
  tmpFen.forEach((size, idx) => {
    const timeSlots = timeTable.time.slice(indexSum - 1, indexSum - 1 + size).map((timeSlot, i) => ({
      ...timeSlot,
      index: i + indexSum
    }));
    
    const daySchedules = {};
    for (let day = 1; day <= 7; day++) {
      daySchedules[day] = [];
      if (schedule[day]) {
        for (let i = indexSum - 1; i < indexSum - 1 + size; i++) {
          daySchedules[day].push(schedule[day][i] || { size: 1 });
        }
      } else {
        for (let i = 0; i < size; i++) {
          daySchedules[day].push({ size: 1 });
        }
      }
    }
    
    renderData.push({
      time: timeSlots,
      schedule: daySchedules,
      size: size / 2,
      group: idx + 1
    });
    
    indexSum += size;
  });
  
  // 不添加额外的时间段，只显示配置的时间段
  
  return renderData;
};
